import type { QuoteStatusType } from '@/components/quotes/StatusBadge';

/**
 * Os status que o PRESTADOR pode escolher no formulário.
 *
 * São QUATRO, e não cinco: `rejected` existe no vocabulário (é o cliente
 * recusando pela página pública), mas nunca foi uma opção de seleção aqui — quem
 * marca "recusado" é o cliente, não quem emite. O Dashboard soma `rejected`
 * junto de `cancelled` no card "Perdido" justamente por isso.
 *
 * Lista ÚNICA de propósito: o cabeçalho da tela de criação (pílulas) e o seletor
 * da tela de edição mostram o mesmo conjunto, e duas listas do mesmo vocabulário
 * é o desastre das unidades (CLAUDE.md #64) esperando para acontecer.
 */
export interface QuoteStatusOption {
  value: QuoteStatusType;
  label: string;
  /** Classe do pontinho colorido (mesmo token do StatusBadge). */
  dot: string;
}

export const QUOTE_STATUS_OPTIONS: readonly QuoteStatusOption[] = [
  { value: 'pending', label: 'Pendente', dot: 'bg-status-pending' },
  { value: 'approved', label: 'Aprovado', dot: 'bg-status-approved' },
  { value: 'completed', label: 'Concluído', dot: 'bg-status-completed' },
  { value: 'cancelled', label: 'Cancelado', dot: 'bg-status-cancelled' },
];

/** Rótulo de qualquer status, inclusive o `rejected` que não é selecionável. */
export const QUOTE_STATUS_LABELS: Record<QuoteStatusType, string> = {
  pending: 'Pendente',
  approved: 'Aprovado',
  completed: 'Concluído',
  cancelled: 'Cancelado',
  rejected: 'Rejeitado',
};
